export type { DomainListEntry } from './domains';
export { getDomainsForEnv, getDomainForLocale, getLocaleDomainByEnvName } from './domains';
export {
  defaultLocale,
  fallbackDefaultLangLocale,
  supportedLocales,
  LocaleContext,
  generateFallbackLng,
  getReleasedCountries,
  getReleasedDomains,
  getDefaultLocaleForDomain,
  getLocalesForDomain,
  getLocalesForCountry,
  getCountryForLocale,
  getCountriesForDomain,
  isGtmEnabledForLocale,
  isJentisEnabledForLocale,
  getPiwikId,
  getDomainsWithMultipleLanguages,
  isVATEnabledForLocale,
  localizeTranslations,
  getLocaleForContext,
  getCountryCodeForContext,
  createNumberFormatter,
} from './locales';
export { hubTranslations } from './generated/hub-frontend/translations';
export { hubLocalizations } from './generated/hub-frontend/localizations';
export { catalogTranslations } from './generated/catalog-frontend/translations';
export { catalogLocalizations } from './generated/catalog-frontend/localizations';
export interface Translations {
  [key: string]: string | Translations;
}
export interface Localizations {
  [key: string]: string | Localizations;
}

export { default as locales } from './resources/locales.json';
export type { LocaleItem, CountryItem, ContinentItem } from './data';
